import { Survey, SurveyAnswer } from '../types';

const onMergeAnswer = (
  state: Survey.ModuleState,
  { id, answer }: SurveyAnswer,
) => {
  const { surveyData, ...rest } = state;

  if (!('surveyData' in state) || surveyData === null) return state;

  return {
    ...rest,
    surveyData: {
      ...surveyData,
      questions: surveyData.questions.map((question) =>
        question.uuid === id ? { ...question, answer } : question,
      ),
    },
  };
};

export default onMergeAnswer;
